import React, { FC } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Grid,
  TextField,
  FormHelperText,
  DialogActions,
  Button, Box,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import theme from '../../../theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Category } from '../interfaces';

interface Props {
  handleClose: () => void;
  open: boolean;
  submitCategory: (data: Category) => Promise<void>;
  loading: boolean;
  categoryName: string | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  }),
);

const CategoryModal: FC<Props> = ({ handleClose, open, submitCategory, loading, categoryName }: Props): React.ReactElement => {
  const { handleSubmit, errors, register } = useForm();
  const classes = useStyles();

  const submitFrom = (values: Category) => {
    submitCategory(values)
  };

  return (
    <Dialog
      onClose={handleClose} aria-labelledby="responsive-dialog-title" open={open}>
      <form onSubmit={handleSubmit(submitFrom)}>
        <DialogContent style={{ padding: "24px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant='outlined'
                  type="text"
                  fullWidth
                  id="name"
                  name="name"
                  defaultValue={categoryName ? categoryName : ''}
                  label="نام دسته بندی"
                  inputRef={register({
                    required: true,
                  })}
                  error={errors.name && true}
                />
                <FormHelperText error focused>
                  {errors.name && 'نام دسته بندی الزامی میباشد'}
                </FormHelperText>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div style={{ width: '100%' }}>
                <TextField
                  variant='outlined'
                  type="text"
                  fullWidth
                  id="code"
                  name="code"
                  label="کد دسته بندی"
                  inputRef={register({
                    required: true,
                    pattern: /^[A-Za-z\d\-_]+$/
                  })}
                  error={errors.code && true}
                />
                <FormHelperText error focused>
                  {errors.code && 'کد دسته بندی الزامی میباشد'}
                </FormHelperText>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: "24px" }}>
          <Grid container spacing={2} justifyContent='flex-end'>
            <Grid item xs={4}>
              <Button
                fullWidth
                type='submit'
                variant="contained"
                color="primary"
                size="large"
                disabled={loading}
              >
                {`ایجاد`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={handleClose}
                variant="contained"
                size="large"
              >
                {`لغو`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CategoryModal;
